export default __webpack_public_path__ + "static/media/img2.6c6dc93e.png";